import {PointsListItem} from '../pointlistitem/pointslistitem.js';
import {mapState, mapGetters, mapActions} from 'pinia';
import './storageselector.css';
import {PopupWindow} from '../popupwindow/popupwindow.js';
import {useRoutingStore} from '../../store.js';
import {ref} from 'vue';
import {InputItem} from '../inputitem/inputitem.js';

export const StorageSelector = {
    props: {
        // Пропсы компонента
    },

    data() {
        return {
            // Локальные данные компонента
            isLoading: false,
            loadedData: [],
            searchInput: ref(null),
            searchActive: false,
            modalActive: false,
            timer: null,
            checkCycle:false
        };
    },

    components: {
        PointsListItem,
        PopupWindow,
        InputItem
    },

    computed: {
        ...mapState(useRoutingStore, [
            'RLStartPoint',
            'IsCycle',
            'storages'
        ]),

    },


    methods: {
        ...mapActions(useRoutingStore, [
            'setStartPoint',
            'setCycle',
            'setZoomPoint',
            'flip',
            'setSearchStatus',
            'deleteStartPoint'
        ]),

        changeStorage(point) {
            const latitude = point['PROPERTY_122'] ? Object.values(point['PROPERTY_122']) : null;
            const longitude = point['PROPERTY_121'] ? Object.values(point['PROPERTY_121']) : null;
            const pointParams = {
                coordinates: [longitude, latitude],
                subtitle: point['NAME'],
                title: "Начало маршрута"
            }
            this.setStartPoint(pointParams);
            this.IsCycle ? this.setCycle(true) : this.setCycle(false)
        },

        setInputRef(el) {
            this.searchInput = el;
        },
        async debouncedInput(value) {
            this.searchInput = value; // Обновляем текущее значение ввода
            this.searchInput.length > 0 ? this.setSearchStatus(true) : this.setSearchStatus(false)

            // Функция для дебаунса
            const debounce = (fnc, delayMs) => {
                clearTimeout(this.timer); // Очищаем предыдущий таймер
                this.timer = setTimeout(fnc, delayMs || 500); // Устанавливаем новый таймер
            };

            // Вызов функции с задержкой
            debounce(async () => {
                this.loadedData = (this.storages.filter((item) => (`${item.NAME ?? ''}`).toLowerCase()
                    .includes(this.searchInput.toLowerCase()))).slice(0,10);
            }, 500);
        },
    },

    watch: {
        // Наблюдатели за изменением значений
    },

    mounted() {
        // Логика, выполняемая при монтировании компонента
        //this.setStorages()
    },

    // language=Vue
    template: `
      <div class="ymap-selector_container" :style="searchActive?{display: 'block'}: null">
          <div class="ymap-selector_container-selected">
            <template v-if="RLStartPoint">
              <PointsListItem
                  :text="RLStartPoint.title"
                  :draggable="false"
                  :onClick="()=>setZoomPoint(RLStartPoint)"
                  :onDelete="()=>{setCycle(false); setStartPoint(null)}"
                  :removable="true"
                  :additionalClasses="'ymap-search_data-item'"
              />
            </template>
            <template v-else>
              <InputItem
                  :inputType="'text'"
                  placeholder="Введите название склада"
                  :changeAction="debouncedInput"
                  :setRef="setInputRef"
                  :isCleanable="true"
              />
              <template v-if="searchInput && searchInput.length>0">
                <div class="ymap-search_data">
                  <template v-for="(item, index) in loadedData">
                    <PointsListItem
                        :text="item.NAME"
                        :draggable="false"
                        :onClick="()=>{changeStorage(item); setSearchStatus(false)}"
                    />
                  </template>
                </div>
              </template>
            </template>
          </div>
        
      </div>
    `
};